import { toast } from "react-toastify";
import { genericCoworkerCompanionAPICall } from "../../connexionApi/connexionApi";
import { SpaceResponse, SpacesResponse } from "./SpacesTypes";
import { Quotas } from "../Quotas/QuotasTypes";
const ENDPOINT_SPACES = "spaces";
const getSpaces = (token: string) => {
  const spacesResult =  genericCoworkerCompanionAPICall(
    token,
    "GET",
    ENDPOINT_SPACES as string,
    ""
  )
    .then((response) => response.json())
    .then((jsonResponse) => jsonResponse as SpacesResponse)
  return spacesResult;
};

const getSpaceById = (token: string, idSpace: number) => {
  const endpoint = `${ENDPOINT_SPACES}/${idSpace}`;
  const spacesResult =  genericCoworkerCompanionAPICall(
    token,
    "GET",
    endpoint,
    ""
  )
    .then((response) => response.json())
    .then((jsonResponse) => jsonResponse as SpaceResponse);
  return spacesResult;
};

const deleteSpace = async (token: string, id: number) => {

  const spaceResult = genericCoworkerCompanionAPICall(
    token,
    "DELETE",
    `${ENDPOINT_SPACES}/${id}/delete`,
    ""
  )

  await toast.promise(
    spaceResult,
    {
      success: 'Space deleted',
      pending: 'Deleting Space',
      error: 'Contact support',
    });

};

const createSpace = async (token: string, space: {name: string; city: string; address: string; postCode: number, charterId: number | undefined, informationId: number | undefined, quotas: Quotas}) => {
  
  const BODY = JSON.stringify({ 
    "Name": space.name,
    "City": space.city,
    "Address": space.address,
    "PostCode": space.postCode,
    "CharterId": space.charterId,
    "InformationId": space.informationId,
    "Quotas": space.quotas
  });

  const spacesResult = genericCoworkerCompanionAPICall(
    token,
    "POST",
    `${ENDPOINT_SPACES}/addSpaces`,
    BODY
  )

  await toast.promise(
    spacesResult,
    {
      success: 'Space created',
      pending: 'Creating Space',
      error: 'Fail to create Space, please contact support or retry with correct informations',
    });
};

const updateSpace = async (token: string, space: { id: number; name: string; city: string; address: string; postCode: number, charterId: number | undefined, informationId: number | undefined, quotas: Quotas;}) => {
  const BODY = JSON.stringify({
    "Id": space.id,
    "Name": space.name,
    "City": space.city,
    "Address": space.address,
    "PostCode": space.postCode,
    "CharterId": space.charterId,
    "InformationId": space.informationId,
    "Quotas": space.quotas
  });

  const spacesResult = genericCoworkerCompanionAPICall(
    token,
    "PUT",
    `${ENDPOINT_SPACES}/${space.id}`,
    BODY
  )

  await toast.promise(
    spacesResult,
    {
      success: 'Space edited',
      pending: 'Editing Space',
      error: 'Contact support',
    });

};


export { getSpaces, getSpaceById, deleteSpace, createSpace, updateSpace};
